import { Component, ElementRef, HostListener, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { LoaderService } from '../../../services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { Business, GroupedBusiness, ImageItem, MembershipBranchImageType } from '../../../models/register-business';
import { Observable, Subscription, catchError } from 'rxjs';
import { ImageConfiguration, ImageConfigurationType } from '../../../models/image-configuration';
import { CropperComponent } from 'angular-cropperjs';
import { NgbActiveModal, NgbModal, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { BusinessService } from '../../../services/business.service';

@Component({
  selector: 'app-pre-register-business-image-configuration',
  templateUrl: './pre-register-business-image-configuration.component.html',
  styleUrls: ['./pre-register-business-image-configuration.component.scss']
})
export class PreRegisterBusinessImageConfigurationComponent implements OnInit {
  @ViewChild('modalContainer', { static: true }) modalContainer!: ElementRef;
  @ViewChild('confirmationModal') confirmationModal!: TemplateRef<any>;
  active: string = "1";
  currentBatchId: number = 0;
  groupedImageData: GroupedBusiness[] = [];
  inputImg: string = '../assets/images/no-image.jpg';
  @ViewChild('angularCropperHome') angularCropperHome!: CropperComponent;
  @ViewChild('angularCropperDetail') angularCropperDetail!: CropperComponent;
  @ViewChild('angularCropperMobile') angularCropperMobile!: CropperComponent;
  lstImageConfigurationDetail: ImageConfiguration[] = [];
  modalHeight: number;
  modalWidth: number;
  homeCropDetail: any;
  detailCropDetail: any;
  mobileCropDetail: any;
  subscribtion: Subscription;
  isShow: boolean;
  inverseScale: number;
  imageWidth: number;
  imageHeight: number;
  homeCanvas: any;
  homeCropBox: any;
  detailCanvas: any;
  detailCropBox: any;
  mobileCanvas: any;
  mobileCropBox: any;
  private resizeImageTimer: ReturnType<typeof setTimeout> | null = null;
  allUncroppedImages: ImageItem[] = [];
  uniqueBusinessIds: number[] = [];
  currentImageIndex: number = 0;
  currentImage: any;
  isPublishShow: boolean = false;
  prevIndex: number = 0;
  prevImage: any;
  businessDetails: Business = new Business();

  configMobile: any = {
    aspectRatio: 340 / 300,
    movable: false,
    zoomable: false,
    scalable: false,
    autoCropArea: 1,
    responsive: true,
    background: false,
    checkCrossOrigin: false,
    checkOrientation: false,
    viewMode: 1,
    minContainerHeight: 300,
  }

  configDetail: any = {
    aspectRatio: 1.45 / 1,
    movable: false,
    zoomable: false,
    scalable: false,
    autoCropArea: 1,
    responsive: true,
    background: false,
    checkCrossOrigin: false,
    checkOrientation: false,
    viewMode: 1,
    minContainerHeight: 300,
  }

  configHome: any = {
    aspectRatio: 3.2 / 1,
    movable: false,
    zoomable: false,
    scalable: false,
    autoCropArea: 1,
    responsive: true,
    background: false,
    checkCrossOrigin: false,
    checkOrientation: false,
    viewMode: 1,
    minContainerHeight: 300,
  }

  constructor(private toastr: ToastrService,
    private loaderService: LoaderService,
    private userService: UserService,
    private activeModal: NgbActiveModal,
    private businessService: BusinessService) { }

  ngOnInit() {
    this.prepareUncroppedImages(this.groupedImageData);
    this.setCurrentImage();
    this.getImageByBranchId(this.currentImage.imageId, this.currentImage.branchId);
  }

  ngOnDestroy() {
    if (this.resizeImageTimer) {
      clearTimeout(this.resizeImageTimer);
      this.resizeImageTimer = null;
    }
    if (this.subscribtion) {
      this.subscribtion.unsubscribe();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.ngOnDestroy();
    this.adjustModalHeight();
  }

  adjustModalHeight() {
    this.modalHeight = window.innerHeight * 0.60;
    this.modalWidth = window.innerWidth * 0.8;
    if (this.resizeImageTimer) {
      clearTimeout(this.resizeImageTimer);
    }
    if (this.subscribtion) {
      this.subscribtion.unsubscribe();
    }
    this.resizeImageTimer = setTimeout(() => {
      this.resizeImageTimer = null;
      this.subscribtion = this.resizeImage(this.inputImg)
        .subscribe({
          next: (cropped) => {
            this.inputImg = cropped;
            this.isShow = true;
            this.updateActiveCropperConfig();
          },
          // Previously this only logged, leaving the user on an endless spinner. Surface the
          // failure and close so a problem image doesn't look like the screen "did nothing".
          error: (err) => {
            console.error('Image crop preview failed:', err);
            this.toastr.error('Could not load this image for cropping. Please try a different photo.');
            this.activeModal.close(null);
          }
        });
    }, 500);
  }

  getImageByBranchId(imageId: number, branchId: number) {
    this.userService
      .getById(
        `api/tenants/membershipApp/GetImageForMembershipBranch`,
        branchId
      )
      .pipe(
        catchError((error) => {
          if (error.status == 404) {
            throw error;
          } else {
            this.loaderService.setLoading(false);
            throw error;
          }
        })
      )
      .subscribe((response: any) => {
        this.isShow = false;
        const image = response.find(x => x.id == imageId);
        this.inputImg = image.imagePath;
        this.adjustModalHeight();
        this.active = "1";
      });
  }

  onDashboardViewCrop(event: any) {
    this.homeCropDetail = event.detail;
  }

  onDetailViewCrop(event: any) {
    this.detailCropDetail = event.detail;
  }

  onMobileViewCrop(event: any) {
    this.mobileCropDetail = event.detail;
  }

  cropImage(active: string) {
    if (active == "1") {
      if (this.homeCropDetail) {
        let dashboardCropDetails = this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.HomePage);
        if (dashboardCropDetails) {
          dashboardCropDetails.X = this.homeCropDetail.x * this.inverseScale;
          dashboardCropDetails.Y = this.homeCropDetail.y * this.inverseScale;
          dashboardCropDetails.Height = this.homeCropDetail.height * this.inverseScale;
          dashboardCropDetails.Width = this.homeCropDetail.width * this.inverseScale;
        } else {
          const homeDetail = {
            ImageId: 0,
            X: this.homeCropDetail.x * this.inverseScale,
            Y: this.homeCropDetail.y * this.inverseScale,
            Height: this.homeCropDetail.height * this.inverseScale,
            Width: this.homeCropDetail.width * this.inverseScale,
            ImageType: ImageConfigurationType.HomePage
          }
          this.lstImageConfigurationDetail.push(homeDetail);
        }

        this.active = "2";
        this.updateActiveCropperConfig();
        this.resetCropperSetting(this.active);
      }
    }
    else if (active == "2") {
      if (this.detailCropDetail) {
        let detailCropDetails = this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.DetailView);
        if (detailCropDetails) {
          detailCropDetails.X = this.detailCropDetail.x * this.inverseScale;
          detailCropDetails.Y = this.detailCropDetail.y * this.inverseScale;
          detailCropDetails.Height = this.detailCropDetail.height * this.inverseScale;
          detailCropDetails.Width = this.detailCropDetail.width * this.inverseScale;
        } else {
          const detail = {
            ImageId: 0,
            X: this.detailCropDetail.x * this.inverseScale,
            Y: this.detailCropDetail.y * this.inverseScale,
            Height: this.detailCropDetail.height * this.inverseScale,
            Width: this.detailCropDetail.width * this.inverseScale,
            ImageType: ImageConfigurationType.DetailView
          }
          this.lstImageConfigurationDetail.push(detail);
        }

        this.active = "3";
        this.updateActiveCropperConfig();
        this.resetCropperSetting(this.active);
      }
    } else if (active == "3") {
      if (this.mobileCropDetail) {
        let mobileCropDetails = this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.MobileView);
        if (mobileCropDetails) {
          mobileCropDetails.X = this.mobileCropDetail.x * this.inverseScale;
          mobileCropDetails.Y = this.mobileCropDetail.y * this.inverseScale;
          mobileCropDetails.Height = this.mobileCropDetail.height * this.inverseScale;
          mobileCropDetails.Width = this.mobileCropDetail.width * this.inverseScale;
        } else {
          const mobileDetail = {
            ImageId: 0,
            X: this.mobileCropDetail.x * this.inverseScale,
            Y: this.mobileCropDetail.y * this.inverseScale,
            Height: this.mobileCropDetail.height * this.inverseScale,
            Width: this.mobileCropDetail.width * this.inverseScale,
            ImageType: ImageConfigurationType.MobileView
          }
          this.lstImageConfigurationDetail.push(mobileDetail);
        }
      }
    }
  }

  onCloseModal() {
    this.activeModal.close();
    this.ngOnDestroy();
    this.active = "1";
    this.currentImageIndex = 0;
    this.lstImageConfigurationDetail = [];
    this.inputImg = '';
  }

  onSubmit(active: string) {
    if (!this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.HomePage) || !this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.DetailView) || !this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.MobileView)) {
      if (this.angularCropperHome) {
        this.homeCropBox = this.angularCropperHome.cropper.getData();
        this.homeCanvas = this.angularCropperHome.cropper.getCanvasData();
      }
      if (this.angularCropperDetail) {
        this.detailCropBox = this.angularCropperDetail.cropper.getData();
        this.detailCanvas = this.angularCropperDetail.cropper.getCanvasData();
      }
      if (this.angularCropperMobile) {
        this.mobileCropBox = this.angularCropperMobile.cropper.getData();
        this.mobileCanvas = this.angularCropperMobile.cropper.getCanvasData();
      }
      this.cropImage(active);
      if (active == "3") {
        const formData = new FormData();
        formData.append('imageConfiguration', JSON.stringify(this.lstImageConfigurationDetail));
        this.updateImage(formData, this.currentImage.id, this.currentBatchId)
      }
    }
  }

  updateImage(data: FormData, preRegisterImageId: number, batchId: number) {
    this.userService.updatePreRegisterBusinessImage(`api/bliss/updatePreRegisterBusinessImage`, data, preRegisterImageId, batchId)
      .pipe(
        catchError((error) => {
          if (error.status == 404) {
            throw error;
          }
          else {
            this.loaderService.setLoading(false);
            throw error;
          }
        })
      )
      .subscribe((response: any) => {
        if (response) {
          this.toastr.success('Image edited successfully!');
          if (this.currentImageIndex === this.allUncroppedImages.length - 1) {
            this.prevImage = this.allUncroppedImages[this.currentImageIndex - 1];
            if (this.prevImage && this.prevImage.approvalStatus == 8) {
              this.isPublishShow = true;
              this.openConfirmationModal();
            } else {
              this.onCloseModal();
            }
          }
          else {
            this.nextImage();
          }
        } else {
          this.toastr.error('Image not edited successfully!');
        }
        this.loaderService.setLoading(false);
      });
  }

  beforeTabChange = (event: NgbNavChangeEvent) => {
    if (event && (event.activeId == "1" && event.nextId == "3" && !this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.HomePage)
      && !this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.DetailView))) {
      event.preventDefault();
      this.toastr.error("Please complete all the section's crop settings before moving to last!");
      return;
    }
    if (Number(event.nextId) > Number(event.activeId)) {
      this.cropImage(event.activeId);
    }
    if (this.angularCropperHome) {
      this.homeCropBox = this.angularCropperHome.cropper.getData();
      this.homeCanvas = this.angularCropperHome.cropper.getCanvasData();
    }
    if (this.angularCropperDetail) {
      this.detailCropBox = this.angularCropperDetail.cropper.getData();
      this.detailCanvas = this.angularCropperDetail.cropper.getCanvasData();
    }
    if (this.angularCropperMobile) {
      this.mobileCropBox = this.angularCropperMobile.cropper.getData();
      this.mobileCanvas = this.angularCropperMobile.cropper.getCanvasData();
    }
    this.updateActiveCropperConfig();
    this.resetCropperSetting(event.nextId);
  }

  resetCropperSetting = (nextId: string) => {
    if (nextId == "1" && this.homeCropBox) {
      setTimeout(() => {
        this.angularCropperHome?.cropper.setData(this.homeCropBox);
        if (this.homeCanvas) {
          this.angularCropperHome?.cropper.setCanvasData(this.homeCanvas);
        }
      }, 100);
    }
    if (nextId == "2" && this.detailCropBox) {
      setTimeout(() => {
        this.angularCropperDetail?.cropper.setData(this.detailCropBox);
        if (this.detailCanvas) {
          this.angularCropperDetail?.cropper.setCanvasData(this.detailCanvas);
        }
      }, 100);
    }
    if (nextId == "3" && this.mobileCropBox) {
      setTimeout(() => {
        this.angularCropperMobile?.cropper.setData(this.mobileCropBox);
        if (this.mobileCanvas) {
          this.angularCropperMobile?.cropper.setCanvasData(this.mobileCanvas);
        }
      }, 100);
    }
  }

  updateActiveCropperConfig = () => {
    if (this.active == "1") {
      this.configHome = {
        ...this.configHome,
        minContainerHeight: this.imageHeight,
        minContainerWidth: this.imageWidth
      };
    } else if (this.active == "2") {
      this.configDetail = {
        ...this.configDetail,
        minContainerHeight: this.imageHeight,
        minContainerWidth: this.imageWidth
      };
    } else if (this.active == "3") {
      this.configMobile = {
        ...this.configMobile,
        minContainerHeight: this.imageHeight,
        minContainerWidth: this.imageWidth
      };
    }
  }

  resizeImage(imageSrc: string): Observable<string> {
    return new Observable(observer => {
      const img = new Image();
      // Only request CORS for genuinely remote images. Forcing crossOrigin on a non-CORS
      // remote image makes the load fail outright (the old code did this for every source),
      // and it is unnecessary for the data:/blob: URLs used when adding a photo.
      const isRemote = /^https?:\/\//i.test(imageSrc) && imageSrc.indexOf(window.location.origin) !== 0;
      if (isRemote) {
        img.crossOrigin = 'anonymous';
      }

      img.onload = () => {
        try {
          let width = img.naturalWidth || img.width;
          let height = img.naturalHeight || img.height;
          this.inverseScale = 1;

          if (!width || !height) {
            observer.error('invalid-image-size');
            return;
          }

          // Guard the modal measurement: on a freshly opened modal (especially on mobile)
          // getBoundingClientRect can read 0, which previously produced negative canvas
          // sizes and could break the crop screen.
          const modalRect = this.modalContainer?.nativeElement?.getBoundingClientRect();
          const modalW = (modalRect && modalRect.width > 50) ? modalRect.width : (window.innerWidth * 0.8) || 320;
          const modalH = this.modalHeight > 50 ? this.modalHeight : (window.innerHeight * 0.6) || 320;

          if (width > modalW || height > modalH) {
            const maxWidth = Math.max(1, modalW - 50);
            const maxHeight = Math.max(1, modalH - 50);
            const scale = Math.min(maxWidth / width, maxHeight / height);
            this.inverseScale = Math.max(width / maxWidth, height / maxHeight);
            width = Math.max(1, Math.floor(width * scale));
            height = Math.max(1, Math.floor(height * scale));
          }

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            observer.error('no-2d-context');
            return;
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);

          this.imageWidth = width;
          this.imageHeight = height;

          // JPEG keeps the in-memory preview small. A PNG re-encode of a multi-megapixel
          // phone photo is large and memory-heavy (a likely cause of the crop screen
          // crashing on memory-constrained mobile browsers). The actual upload still uses
          // the original file + crop coordinates, so preview compression is harmless.
          this.inputImg = canvas.toDataURL('image/jpeg', 0.9);

          // Release the working canvas promptly.
          canvas.width = 0;
          canvas.height = 0;

          observer.next(this.inputImg);
          observer.complete();
        } catch (err) {
          observer.error(err);
        }
      };

      // Previously there was no error handler, so a failed/blocked image load left the crop
      // screen stuck on the spinner forever (no completion, no error surfaced).
      img.onerror = () => observer.error('image-load-failed');

      img.src = imageSrc;
    });
  }

  prepareUncroppedImages(businesses: GroupedBusiness[]) {
    this.allUncroppedImages = [];
    const seenBusinessIds = new Set<number>();

    businesses.forEach(business => {
      if (!seenBusinessIds.has(business.businessId)) {
        seenBusinessIds.add(business.businessId);
      }

      business.businessImageData.forEach(imageType => {
        imageType.imageTypeData.forEach(image => {
          if (!image.isCropped) {
            this.allUncroppedImages.push({
              businessId: business.businessId,
              businessName: business.businessName,
              approvalStatus: business.approvalStatus,
              imageTypeId: imageType.imageTypeId,
              id: image.id,
              branchId: image.branchId,
              imageName: image.imageName,
              isCropped: image.isCropped,
              imageId: image.imageId,
              isBatchCompleted: image.isBatchCompleted,
              total: 0,
              index: 0
            });
          }
        });
      });
    });

    this.uniqueBusinessIds = Array.from(seenBusinessIds);
    this.allUncroppedImages.forEach((img, i) => {
      img.index = i + 1;
      img.total = this.allUncroppedImages.length;
    })
  }

  setCurrentImage() {
    this.currentImage = this.allUncroppedImages[this.currentImageIndex];
    const index = this.groupedImageData.findIndex(b => b.businessId === this.currentImage.businessId);
    if (index != this.prevIndex) {
      this.prevImage = this.allUncroppedImages[this.currentImageIndex - 1];
      if (this.prevImage && this.prevImage.approvalStatus == 8) {
        this.isPublishShow = true;
        this.openConfirmationModal();
      }
    }
    this.prevIndex = index;
    this.getImageByBranchId(this.currentImage.imageId, this.currentImage.branchId)
  }

  nextImage() {
    if (this.currentImageIndex < this.allUncroppedImages.length - 1) {
      this.currentImageIndex++;
      this.lstImageConfigurationDetail = [];
      this.homeCropDetail = null;
      this.detailCropDetail = null;
      this.mobileCropDetail = null;
      this.homeCanvas = null;
      this.homeCropBox = null;
      this.detailCanvas = null;
      this.detailCropBox = null;
      this.mobileCanvas = null;
      this.mobileCropBox = null;

      this.ngOnDestroy();
      this.setCurrentImage();
    }
  }

  previousImage() {
    if (this.currentImageIndex > 0) {
      this.currentImageIndex--;
      this.setCurrentImage();
    }
  }

  getBusinessIndex(image: any): number {
    const index = this.groupedImageData.findIndex(b => b.businessId === image.businessId);
    return index + 1;
  }

  getTotalBusinesses(): number {
    return this.groupedImageData.length;
  }

  getTotalImagesInType(image: any): number {
    const business = this.groupedImageData.find(b => b.businessId === image.businessId);
    const type = business?.businessImageData.find(t => t.imageTypeId === image.imageTypeId);
    return type?.imageTypeData.length || 0;
  }

  getImageIndexInType(image: any): number {
    const business = this.groupedImageData.find(b => b.businessId === image.businessId);
    const type = business?.businessImageData.find(t => t.imageTypeId === image.imageTypeId);
    const index = type?.imageTypeData.findIndex(i => i.imageName === image.imageName);
    return (index ?? 0) + 1;
  }

  getImageTypeName(id: number): string {
    return MembershipBranchImageType[id] || `Type ${id}`;
  }

  publishRestaurant = () => {
    this.loaderService.setLoading(true);
    this.businessService
      .getBusinessById(this.prevImage.branchId)
      .subscribe((response: any) => {
        this.businessDetails = response;
        this.userService
          .create(`api/bliss/business/publish`, this.businessDetails)
          .pipe(
            catchError((error) => {
              if (error.status == 404) {
                throw error;
              } else {
                this.loaderService.setLoading(false);
                throw error;
              }
            })
          )
          .subscribe(() => {
            this.loaderService.setLoading(false);
            this.close();
          });
      });
  }

  private modalService = inject(NgbModal);
  openConfirmationModal() {
    const modalRef = this.modalService.open(this.confirmationModal, {
      windowClass: 'delete-section-modal',
      centered: true,
      size: 'sm',
      backdrop: 'static'
    });
  }

  close() {
    this.isPublishShow = false;
    if (this.currentImageIndex === this.allUncroppedImages.length - 1) {
      this.onCloseModal();
    }
  }
}
